import { FC, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useRouteMatch
} from 'react-router-dom'
import { MSPClasses } from '@cms-max/medicare-api-sdk'
import { fetchMspSummaries } from 'redux/helpers/claimCase'
import { cookieInterfaces } from 'utils/cookies'
import { MspDisclaimerPage } from './MspDisclaimerPage'
import { MspErrorPage } from './MspErrorPage'
import { MspMainPage } from './MspMainPage'
import { useFlags } from 'launchdarkly-react-client-sdk'

type DisclaimerCheckProps = {
  acceptedDisclaimer: boolean
  children: React.ReactNode
}
const DisclaimerCheck = ({
  acceptedDisclaimer,
  children
}: DisclaimerCheckProps) => {
  const { path } = useRouteMatch()

  if (!acceptedDisclaimer) {
    return <Redirect to={`${path}/disclaimer`} />
  }
  return <>{children}</>
}

export const MSP: FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()

  const flags = useFlags()
  useEffect(() => {
    dispatch(fetchMspSummaries({
      classType: MSPClasses.MspSummary,
      useOnlySlsJwtForAuthByDefault: flags?.useOnlySlsJwtForAuthByDefault
    }))
  // eslint-disable-next-line react-hooks/exhaustive-deps --- we don't need flags here because they shouldn't change, and LD should be loaded before this component renders since it's behind LaunchDarklyDependentContent
  }, [dispatch])

  const [acceptedDisclaimer, setAcceptedDisclaimer] = useState(
    Boolean(cookieInterfaces.acceptedMspDisclaimer.get())
  )
  useEffect(() => {
    if (acceptedDisclaimer) {
      cookieInterfaces.acceptedMspDisclaimer.set('true')
    }
  }, [acceptedDisclaimer])
  const handleAcceptDisclaimer = () => {
    setAcceptedDisclaimer(true)
    history.push('/claims/msp')
  }

  return (
    <Switch>
      <Route path={`/claims/msp/disclaimer`}>
        <MspDisclaimerPage onAccept={handleAcceptDisclaimer} />
      </Route>
      <Route path={`/claims/msp/error`}>
        <MspErrorPage />
      </Route>
      <Route path={`/claims/msp`}>
        <DisclaimerCheck acceptedDisclaimer={acceptedDisclaimer}>
          <MspMainPage />
        </DisclaimerCheck>
      </Route>
    </Switch>
  )
}

export default MSP
